module.exports = __webpack_public_path__ + "img/discount-bg.bb6be42.png";